/* Real document previews remain on the homepage, including in Theme Editor. */
(() => {
  if (window.flashFishHomeDocuments) return;
  const initialize = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-ff-home-documents]')];
    if (scope.matches?.('[data-ff-home-documents]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.documentsReady) return;
      root.dataset.documentsReady = 'true';
      root.querySelector('[data-doc-filters]').hidden = false;
      const dialog = root.querySelector('[data-doc-dialog]');
      const filter = (value) => {
        root.querySelectorAll('[data-doc-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.docFilter === value)));
        root.querySelectorAll('[data-doc-card]').forEach((card) => {
          card.hidden = value === 'featured' ? !card.hasAttribute('data-doc-featured') : !card.dataset.docModels.split(',').map((s) => s.trim()).includes(value);
        });
      };
      root.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !root.contains(button)) return;
        if (button.hasAttribute('data-doc-filter')) filter(button.dataset.docFilter);
        if (button.hasAttribute('data-doc-preview')) {
          root.querySelector('[data-doc-dialog-title]').textContent = button.dataset.docTitle;
          root.querySelector('[data-doc-dialog-caption]').textContent = button.dataset.docCaption;
          const image = root.querySelector('[data-doc-dialog-image]');
          if (button.dataset.docWidth && button.dataset.docHeight) {
            image.width = Number(button.dataset.docWidth);
            image.height = Number(button.dataset.docHeight);
          }
          image.src = button.dataset.docSrc;
          image.alt = button.dataset.docTitle + ' — ' + button.dataset.docCaption;
          dialog.showModal();
          root.querySelector('.ff-document-dialog__page').scrollTop = 0;
        }
        if (button.hasAttribute('data-doc-close')) dialog.close();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      root.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('[data-doc-card]');
        if (card) filter(card.dataset.docModels.split(',')[0].trim());
      });
    });
  };
  window.flashFishHomeDocuments = { initialize };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelector('[data-doc-dialog]')?.close());
})();
